"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var Login_styled_1 = require("./Login.styled");
var icons_material_1 = require("@mui/icons-material");
var LoadingButton_1 = __importDefault(require("@mui/lab/LoadingButton"));
var useFetchLogin_1 = require("../../hooks/fetch/users/useFetchLogin");
var Auth_1 = require("../../context/Auth");
var MerchantConfig_1 = require("../../context/MerchantConfig");
var is_empty_1 = __importDefault(require("is-empty"));
var react_toastify_1 = require("react-toastify");
var services_1 = require("../../services");
var styles_1 = require("../../styles");
var constants_1 = require("../../constants");
var Login = function () {
    var _a = (0, react_1.useState)(''), email = _a[0], setEmail = _a[1];
    var _b = (0, react_1.useState)(''), password = _b[0], setPassword = _b[1];
    var _c = (0, react_1.useState)(false), showPassword = _c[0], setShowPassword = _c[1];
    var handleClickShowPassword = function () { return setShowPassword(function (show) { return !show; }); };
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _d = (0, Auth_1.useAuth)(), setUserTokens = _d.setUserTokens, setUserData = _d.setUserData;
    var merchantConfig = (0, MerchantConfig_1.useMerchantConfig)().merchantConfig;
    var loginMutation = (0, useFetchLogin_1.useFetchLogin)();
    var handleSubmit = function (ev) {
        ev.preventDefault();
        loginMutation.mutate({ email: email, password: password }, {
            onSuccess: function (_a) {
                var data = _a.data;
                return __awaiter(void 0, void 0, void 0, function () {
                    var dataUser;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!!data.statusCode &&
                                    data.statusCode === 400 &&
                                    Array(data).length === 0) {
                                    react_toastify_1.toast.error('Error en el servidor');
                                }
                                if (!!data.statusCode &&
                                    (data.statusCode === 400 || data.statusCode === 401) &&
                                    (Array(data).length > 0 || String(data).length > 0)) {
                                    react_toastify_1.toast.error(data.message);
                                }
                                if (!data.token) return [3 /*break*/, 2];
                                services_1.api.defaults.headers['authorization-token'] = "Bearer ".concat(data.token);
                                setUserTokens(data);
                                return [4 /*yield*/, services_1.UserService.me(data.token)];
                            case 1:
                                dataUser = _b.sent();
                                setUserData(dataUser);
                                navigate(constants_1.DASHBOARD_PATH, { replace: true });
                                _b.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                });
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(Login_styled_1.PageWrapper, { children: (0, jsx_runtime_1.jsx)(styles_1.WrapperCenter, { children: (0, jsx_runtime_1.jsxs)(Login_styled_1.CardForm, { children: [(0, jsx_runtime_1.jsxs)(Login_styled_1.LoginHeaderForm, { children: [!(0, is_empty_1.default)(merchantConfig) ? ((0, jsx_runtime_1.jsx)(Login_styled_1.ImgLogo, { src: merchantConfig.project_config.merchant_logo, alt: "Logo Cliente B2B" })) : ((0, jsx_runtime_1.jsx)(material_1.Skeleton, { animation: "wave", variant: "rectangular", width: 200, height: 60 })), (0, jsx_runtime_1.jsx)(Login_styled_1.WelcomeWrapper, { children: (0, jsx_runtime_1.jsx)(Login_styled_1.WelcomeMessage, { children: "Ingresa tus credenciales para continuar" }) })] }), (0, jsx_runtime_1.jsxs)(Login_styled_1.FormAuth, __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsxs)(Login_styled_1.FormGroup, { children: [(0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "standard" }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { id: "filled-basic", label: "Correo Electr\u00F3nico", variant: "filled", value: email, onChange: function (event) { return setEmail(event.target.value); }, required: true }) })), (0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "filled" }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ htmlFor: "password" }, { children: "Contrase\u00F1a" })), (0, jsx_runtime_1.jsx)(material_1.FilledInput, { id: "password", type: showPassword ? 'text' : 'password', value: password, onChange: function (event) { return setPassword(event.target.value); }, required: true, endAdornment: (0, jsx_runtime_1.jsx)(material_1.InputAdornment, __assign({ position: "end" }, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ "aria-label": "toggle password visibility", onClick: handleClickShowPassword }, { children: showPassword ? (0, jsx_runtime_1.jsx)(icons_material_1.VisibilityOff, {}) : (0, jsx_runtime_1.jsx)(icons_material_1.Visibility, {}) })) })) })] }))] }), (0, jsx_runtime_1.jsx)(Login_styled_1.FormActions, { children: (0, jsx_runtime_1.jsx)(LoadingButton_1.default, __assign({ type: "submit", variant: "contained", fullWidth: true, size: "large", style: { textTransform: 'none' }, loading: loginMutation.isLoading && !loginMutation.isError, loadingIndicator: "Ingresando\u2026" }, { children: "Ingresar" })) })] }))] }) }) }));
};
exports.default = Login;
